import { useState } from "react";
import { Input, Form, Icon, CancelButton, CancelIcon } from "./styled";

function Search({ placeholder, className, onSearch, value }) {
  const [searchTerm, setSearchTerm] = useState("");
  const handleChange = (e) => {
    onSearch(e.target.value);
    setSearchTerm(e.target.value);
  };
  const onKeyDown = (e) => {
    if(e.key === 'Enter') {
      e.preventDefault();
    }
  }
  const clearSearch = () => {
    onSearch("");
    setSearchTerm("");
  };

  return (
    <Form
      className={className}
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <Input
        type="text"
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        value={searchTerm}
      />
      {searchTerm.length > 0 && (
        <CancelButton aria-label="clear search" onClick={clearSearch}>
          <CancelIcon viewBox="0 0 987.66 987.66"><path className="b" d="M970.38,17.28c-23.04-23.04-60.4-23.04-83.44,0L493.83,410.39,100.72,17.28c-23.04-23.04-60.4-23.04-83.44,0-23.04,23.04-23.04,60.4,0,83.44L410.39,493.83,17.28,886.94c-23.04,23.04-23.04,60.4,0,83.44,11.52,11.52,26.62,17.28,41.72,17.28s30.2-5.76,41.72-17.28l393.11-393.11,393.11,393.11c11.52,11.52,26.62,17.28,41.72,17.28s30.2-5.76,41.72-17.28c23.04-23.04,23.04-60.4,0-83.44l-393.11-393.11L970.38,100.72c23.04-23.04,23.04-60.4,0-83.44Z"/></CancelIcon>
        </CancelButton>
      )}
      <Icon src="/search.svg" alt="" />
    </Form>
  );
}

export default Search;
